// extracted by mini-css-extract-plugin
module.exports = {"filtersSectionWrapper":"filtersSectionWrapper_1_Rpr","seatingPlanContent":"seatingPlanContent_3AxQC"};